import { fabric } from 'fabric';

export const initMagicEraserCanvases = ({ width, height }) => {
  const manipulationCanvas = new fabric.StaticCanvas(
    'manipulation-magic-eraser-canvas',
    {
      selection: false,
      width,
      height,
      enableRetinaScaling: false,
    }
  );
  window.magicEraserManipulationCanvas = manipulationCanvas;

  const drawingCanvas = new fabric.Canvas('drawing-magic-eraser-canvas', {
    selection: false,
    width,
    height,
    enableRetinaScaling: false,
  });

  window.magicEraserDrawingCanvas = drawingCanvas;
};
